var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Model } from "vue-property-decorator";
var NumTypeSelect = /** @class */ (function (_super) {
    __extends(NumTypeSelect, _super);
    function NumTypeSelect() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NumTypeSelect.prototype.updateNumType = function (type) { };
    NumTypeSelect.prototype.emitNumTypeChange = function (type) { };
    Object.defineProperty(NumTypeSelect.prototype, "numType", {
        get: function () {
            return this.currentNumType;
        },
        set: function (val) {
            this.updateNumType(val);
        },
        enumerable: false,
        configurable: true
    });
    NumTypeSelect.prototype.onNumTypeChange = function () {
        this.emitNumTypeChange(this.numType);
    };
    __decorate([
        Model("updateNumType")
    ], NumTypeSelect.prototype, "currentNumType", void 0);
    __decorate([
        Emit("updateNumType")
    ], NumTypeSelect.prototype, "updateNumType", null);
    __decorate([
        Emit("onNumTypeChange")
    ], NumTypeSelect.prototype, "emitNumTypeChange", null);
    NumTypeSelect = __decorate([
        Component({
            components: {}
        })
    ], NumTypeSelect);
    return NumTypeSelect;
}(Vue));
export default NumTypeSelect;
